import { EmptyPageState, PageHeading } from '@traceio-org/ui';
import { AdminPage } from '../components/AdminPage';
import { ActionLink } from '../components/AdminProblem';
import { ADMIN_SECTIONS, LATER_LABEL, sectionIcon, type AdminSectionId } from '../navigation';

/**
 * Jobs: the page says the area is coming later and shows no data at all, real or invented.
 */
export function PlaceholderPage({ sectionId }: { sectionId: Extract<AdminSectionId, 'jobs'> }) {
  const section = ADMIN_SECTIONS.find((s) => s.id === sectionId);
  const label = section?.label ?? sectionId;
  return (
    <AdminPage title={label}>
      <PageHeading eyebrow={LATER_LABEL} title={label} />
      <EmptyPageState
        icon={section ? sectionIcon(section) : undefined}
        title={LATER_LABEL}
        description={`${label} is a placeholder in Trace Admin until a later milestone. It shows no data before then.`}
        action={<ActionLink to="/">Go to Health</ActionLink>}
      />
    </AdminPage>
  );
}

export function NotFoundPage() {
  return (
    <AdminPage title="Page not found">
      <PageHeading title="Page not found" description="Trace Admin has no page at this address." />
      <div className="admin-problem-actions">
        <ActionLink primary to="/">
          Go to Health
        </ActionLink>
      </div>
    </AdminPage>
  );
}
